<template>
    <div v-if="userData">
        <vue-headful :title="$t('editMyProfile')" />
        <!-- Настройки контактов -->
        <ContactEdit :userData="userData" :uploadSettings="uploadSettings" />


        <!-- Настройки интересов -->
<!--        <InterestEdit v-if="user.role && user.role.is_student" :userData="userData" />-->

        <!-- Настройки соц.сети -->
        <LinkSocialEdit v-if="user.role && user.role.is_student" :userData="userData" />

        <!-- Настройки достижений -->
<!--        <AchievementEdit v-if="user.role && user.role.is_student" :userData="userData" />-->
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import ContactEdit from './ContactEdit'
import InterestEdit from './InterestEdit'
import AchievementEdit from './AchievementEdit'
import LinkSocialEdit from './LinkSocialEdit'

export default {
    components: {
        ContactEdit,
        InterestEdit,
        AchievementEdit,
        LinkSocialEdit
    },
    data() {
        return {
            userData: null,
            uploadSettings: null
        }
    },
    created: function() {
        this.getUserData()
    },
    computed: {
        user() {
            return this.$store.state.user.user
        }
    },
    methods: {
        // Получаем информация о пользователе
        async getUserData() {
            try {
                this.$vs.loading()

                const {data} = await this.$http.get(`/user/profile/${ this.user.profileId }/`)
                this.uploadSettings = (await this.$http.get(`/common/settings/`)).data[0]

                this.userData = data
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close()
            }
        }
    }
}
</script>

<style lang="scss">
.edt_btn{
    .vs-icon{
        z-index: 10;
    }
}
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}
@media only screen and (max-width: 900px) {
    .contact_btn{
        width: 100%;
    }
    .mb_reverse{
        display: flex;
        flex-direction: column-reverse;
        flex-wrap: wrap;
        button{
            &:last-child{
                margin-bottom: 6px;
            }
        }
    }
}
</style>
